import {
    Component,
    ElementRef,
    HostListener,
    OnInit,
    ViewChild,
} from "@angular/core";

import { map, Observable, shareReplay } from "rxjs";

import { stopEventPropagation } from "@hermes/utils-generic/helpers";

import { ZoomService } from "../../services/zoom.service";

@Component({
    selector: "h-image-zoom-scale-slider",
    templateUrl: "./image-zoom-scale-slider.component.html",
    styleUrls: ["./image-zoom-scale-slider.component.scss"],
})
export class ImageZoomScaleSliderComponent implements OnInit {
    @ViewChild("track", { static: true })
    private track!: ElementRef<HTMLElement>;

    public thumbTranslate$: Observable<string>;
    public trackBackground$: Observable<string>;
    public scalePercentage$: Observable<number>;
    public minScale: number;
    public maxScale: number;
    public thumbSize = 24;
    private isDragging: boolean = false;

    constructor(private readonly zoomService: ZoomService) {
        const whenThumbMove$ = this.zoomService.thumbMoved$.pipe(shareReplay());

        this.thumbTranslate$ = whenThumbMove$.pipe(
            map(({ position }) => this.translateThumb(position)),
        );
        this.trackBackground$ = whenThumbMove$.pipe(
            map(({ position }) => this.updateTrackLine(position)),
        );
        this.scalePercentage$ = whenThumbMove$.pipe(
            map(({ scalePercentage }) => scalePercentage),
        );

        this.minScale = this.zoomService.minScale;
        this.maxScale = this.zoomService.maxScale;
    }

    /**
     * handle drag in drop on slider
     */
    @HostListener("document:mousemove", ["$event"])
    public onMouseMove({ clientY: cursorY }: MouseEvent): void {
        const { bottom, top } = this.zoomService.track;
        const isCursorInsideYAxis = cursorY < bottom && cursorY > top;

        if (this.isDragging && isCursorInsideYAxis) {
            const position = Math.abs(bottom - cursorY);
            this.zoomService.scaleImageFromThumb(position);
        }
    }

    @HostListener("document:mouseup", ["$event"])
    public onMouseUp(): void {
        this.isDragging = false;
    }
    public ngOnInit(): void {
        this.zoomService.setTrackRect(this.track);
    }

    public onMouseDown(event: MouseEvent): void {
        // prevent selection start (browser action)
        stopEventPropagation(event);
        this.isDragging = true;
    }

    public decrement(event: Event): void {
        event.stopPropagation();
        this.zoomService.decrement(1 / 2);
    }

    public increment(event: Event): void {
        event.stopPropagation();
        this.zoomService.increment(1 / 2);
    }

    private updateTrackLine(position: number): string {
        return `linear-gradient(0deg, rgb(68 68 68) ${position}px , rgb(145 145 145) ${position}px)`;
    }

    private translateThumb(position: number): string {
        const halfHeight = this.thumbSize / 2;
        const x = -position + halfHeight;

        return `translate(-50%, ${x}px)`;
    }
}
